import { render, staticRenderFns } from "./card-table.vue?vue&type=template&id=99f862e4&scoped=true&"
import script from "./card-table.vue?vue&type=script&lang=js&"
export * from "./card-table.vue?vue&type=script&lang=js&"
import style0 from "./card-table.vue?vue&type=style&index=0&id=99f862e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f862e4",
  null
  
)

export default component.exports